<template>
  <div class="yoyo-container mx-auto min-h-screen">
    <!-- 导航栏 -->
    <navBar :title="$t('binds.title')"></navBar>

    <!-- 标签页 -->
    <van-tabs v-model="activeTab" class="bind-tabs yoyo-container" sticky offset-top="3rem" @change="onTabChange">
      <van-tab :title="$t('binds.simCard')" name="sim">
        <!-- SIM卡列表 -->
        <van-pull-refresh v-model="simRefreshing" @refresh="onRefreshSim" v-if="simCards.length > 0">
          <van-list
            v-model="simLoading"
            :finished="simFinished"
            :finished-text="$t('query.noMoreData')"
            :loading-text="$t('query.loading')"
            @load="onLoadSim">
            <BindingCard :cards="simCards" type="sim" @query="handleQuery" @recharge="handleRecharge" @delete="handleDeleteBinding" />
            <div class="px-4 py-3 text-[13px] text-gray-700">{{ $t("binds.note") }}</div>
          </van-list>
        </van-pull-refresh>
        <div v-else>
          <BindingCard :cards="simCards" type="sim" @query="handleQuery" @recharge="handleRecharge" @delete="handleDeleteBinding" />
          <div class="px-4 py-3 text-[13px] text-gray-700">{{ $t("binds.note") }}</div>
        </div>
      </van-tab>

      <van-tab :title="$t('binds.esim')" name="esim">
        <!-- eSIM列表 -->
        <van-pull-refresh v-model="esimRefreshing" @refresh="onRefreshEsim" v-if="esimCards.length > 0">
          <van-list
            v-model="esimLoading"
            :finished="esimFinished"
            :finished-text="$t('query.noMoreData')"
            :loading-text="$t('query.loading')"
            @load="onLoadEsim">
            <BindingCard :cards="esimCards" type="esim" @query="handleQuery" @recharge="handleRecharge" @delete="handleDeleteBinding" />
          </van-list>
        </van-pull-refresh>
        <div v-else>
          <BindingCard :cards="esimCards" type="esim" @query="handleQuery" @recharge="handleRecharge" @delete="handleDeleteBinding" />
        </div>
      </van-tab>
    </van-tabs>

    <!-- 底部按钮 -->
    <van-button type="primary" round class="mx-16 w-[calc(100%-8rem)] my-4 bg-orange-500 border-none" @click="handleNewBinding">
      {{ $t("binds.newBinding") }}
    </van-button>

    <!-- 删除确认弹窗 -->
    <van-dialog
      v-model="showDeleteDialog"
      :title="$t('binds.confirmDelete')"
      show-cancel-button
      :confirm-button-text="$t('common.confirm')"
      :cancel-button-text="$t('common.cancel')"
      @confirm="confirmDelete" />

    <!-- 添加绑定 -->
    <CommonDialog
      :visible.sync="showBindPopup"
      :title="$t('binds.newBinding')"
      :buttons="[
        { text: this.$t('common.cancel'), type: 'secondary', action: 'cancel' },
        { text: this.$t('common.confirm'), type: 'primary', action: 'confirm' },
      ]"
      @button-click="handleBindClick"
      @close="handleClose">
      <div class="my-4">
        <van-field
          v-model="iccid"
          :placeholder="$t('binds.addBindingPlaceholder')"
          rows="2"
          show-word-limit
          :border="false"
          class="bg-gray-50 rounded-lg" />
      </div>
    </CommonDialog>
  </div>
</template>

<script>
import { Tabs, Tab, Button, Dialog, PullRefresh, List, Toast } from "vant"
import BindingCard from "@/components/mine/BindingCard.vue"
import { getBindingList, addBinding, deleteBinding } from "@/apis/mine"

export default {
  name: "MyBinds",
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    BindingCard,
  },
  data() {
    return {
      activeTab: "sim",
      showDeleteDialog: false,
      deleteCard: null,
      // SIM卡分页
      simCards: [],
      simLoading: false,
      simFinished: false,
      simRefreshing: false,
      simPageNo: 1,
      simPageSize: 10,
      // eSIM分页
      esimCards: [],
      esimLoading: false,
      esimFinished: false,
      esimRefreshing: false,
      esimPageNo: 1,
      esimPageSize: 10,
      showBindPopup: false,
      iccid: "",
    }
  },
  methods: {
    // 标签页切换
    onTabChange() {
      if (this.activeTab === "sim" && this.simCards.length === 0) {
        this.getBindingList(false)
      } else if (this.activeTab === "esim" && this.esimCards.length === 0) {
        this.getBindingList(true)
      }
    },
    // SIM卡 - 下拉刷新
    onRefreshSim() {
      this.simPageNo = 1
      this.simFinished = false
      this.simCards = []
      this.getBindingList(false)
    },
    // SIM卡 - 上拉加载
    onLoadSim() {
      this.getBindingList(false)
    },
    // eSIM - 下拉刷新
    onRefreshEsim() {
      this.esimPageNo = 1
      this.esimFinished = false
      this.esimCards = []
      this.getBindingList(true)
    },
    // eSIM - 上拉加载
    onLoadEsim() {
      this.getBindingList(true)
    },
    // 获取绑定列表
    async getBindingList(isEsim = false) {
      try {
        const params = {
          pageNo: isEsim ? this.esimPageNo : this.simPageNo,
          pageSize: isEsim ? this.esimPageSize : this.simPageSize,
          spuType: isEsim ? "eSIM" : "SIM",
        }
        const res = await getBindingList(params)
        const list = res.data.list || []

        if (isEsim) {
          // eSIM记录
          if (this.esimPageNo === 1) {
            this.esimCards = list
            this.esimRefreshing = false
          } else {
            this.esimCards = [...this.esimCards, ...list]
          }
          this.esimLoading = false

          // 判断是否加载完
          if (res.data.total <= this.esimCards.length) {
            this.esimFinished = true
          } else {
            this.esimPageNo++
          }
        } else {
          // SIM卡记录
          if (this.simPageNo === 1) {
            this.simCards = list
            this.simRefreshing = false
          } else {
            this.simCards = [...this.simCards, ...list]
          }
          this.simLoading = false

          // 判断是否加载完
          if (res.data.total <= this.simCards.length) {
            this.simFinished = true
          } else {
            this.simPageNo++
          }
        }

        console.log("绑定列表:", res)
      } catch (error) {
        if (isEsim) {
          this.esimLoading = false
          this.esimRefreshing = false
        } else {
          this.simLoading = false
          this.simRefreshing = false
        }
      }
    },
    handleQuery(card) {
      // 跳转到查询页面
      this.$router.push({ path: "/query", query: { iccid: card.iccid } })
    },
    handleRecharge(card) {
      // 跳转到充值页面
      this.$router.push({ path: "/rechargeDetail", query: { id: card.spuId, type: "SIM", iccid: card.iccid } })
    },
    handleDeleteBinding(card) {
      this.deleteCard = card
      this.showDeleteDialog = true
    },
    handleNewBinding() {
      this.iccid = ""
      this.showBindPopup = true
    },
    handleBindClick(e) {
      const { action } = e
      if (action === "cancel") {
        this.showBindPopup = false
      } else if (action === "confirm") {
        addBinding({ iccid: this.iccid })
          .then((res) => {
            Toast.success(this.$t("binds.addBindingSuccess"))
            this.showBindPopup = false
            this.getBindingList(this.activeTab === "sim" ? false : true)
          })
          .catch((error) => {
            console.log("添加绑定失败:", error)
          })
      }
    },
    handleClose() {
      this.showBindPopup = false
    },
    async confirmDelete() {
      if (!this.deleteCard) return

      try {
        await deleteBinding({ id: this.deleteCard.id })
        Toast.success(this.$t("binds.deleteSuccess"))
        this.showDeleteDialog = false

        // 删除成功后刷新当前列表
        if (this.activeTab === "sim") {
          this.onRefreshSim()
        } else {
          this.onRefreshEsim()
        }
      } catch (error) {
        console.log("删除绑定失败:", error)
        Toast.fail(this.$t("binds.deleteFailed") || "删除失败")
      } finally {
        this.deleteCard = null
      }
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  created() {
    this.getBindingList(false)
  },
}
</script>

<style scoped>
:deep(.van-sticky) {
  width: 100%;
}
@media (width >= 40rem) {
  :deep(.van-sticky) {
    max-width: 40rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}

@media (width >= 48rem) {
  :deep(.van-sticky) {
    max-width: 48rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}

@media (width >= 64rem) {
  :deep(.van-sticky) {
    max-width: 64rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}
@media (width >= 80rem) {
  :deep(.van-sticky) {
    max-width: 64rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}
@media (width >= 96rem) {
  :deep(.van-sticky) {
    max-width: 72rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}
</style>
